import { useEffect, useState } from 'react';
import './modalStyle.css';

interface LocationText {
  x: number;
  y: number;
}

interface ModalStyleProps {
  locationTextNode: LocationText;
  setShowModalStyle: (show: boolean) => void;
  handleChangeSize: (value: string) => void;
  handleChangeColor: (value: string) => void;
  handleChangeStyle: (value: string) => void;
  handleChangeAlignment: (value: string) => void;
  handleChangeFont: (value: string) => void;
}

const ModalStyle = ({
  locationTextNode,
  setShowModalStyle,
  handleChangeSize,
  handleChangeColor,
  handleChangeStyle,
  handleChangeAlignment,
  handleChangeFont
}: ModalStyleProps) => {
  const [size, setSize] = useState(20);
  const [animateClass, setAnimateClass] = useState('modal-enter');

  useEffect(() => {
    setAnimateClass('modal-enter');
    return () => {
      setAnimateClass('modal-exit');
    };
  }, []);

  const closeHandler = () => {
    setAnimateClass('modal-exit');
    setTimeout(() => {
      setShowModalStyle(false);
    }, 300);
  };

  return (
    <div
      className={`position-absolute p-3 rounded bg-light shadow ${animateClass}`}
      style={{
        top: locationTextNode.y - 50,
        left: locationTextNode.x,
        transform: `${
          locationTextNode.y > 400 ? 'translate(0, -90%)' : 'translate(0, 30%)'
        }`,
        zIndex: 1000,
        width: '250px'
      }}
    >
      <div className="d-flex justify-content-end mb-2 ">
        <button
          onClick={closeHandler}
          className="btn btn-sm font-weight-bold btn-warning"
        >
          X
        </button>
      </div>
      <div className="mb-2">
        <label className="form-label font-weight-bold">
          Font Size:
          <input
            type="number"
            min={0}
            value={size}
            onChange={e => {
              setSize(Number(e.target.value));
              handleChangeSize(e.target.value);
            }}
            className="form-control mt-1"
          />
        </label>
      </div>
      <div className="mb-2">
        <label className="form-label font-weight-bold">
          Font Color:
          <input
            type="color"
            onChange={e => {
              handleChangeColor(e.target.value);
            }}
            className="form-control mt-1"
          />
        </label>
      </div>
      <div className="mb-2">
        <label className="form-label font-weight-bold">
          Font Style:
          <select
            onChange={e => {
              handleChangeStyle(e.target.value);
            }}
            className="form-select mt-1"
          >
            <option value="normal">Normal</option>
            <option value="italic">Italic</option>
            <option value="bold">Bold</option>
          </select>
        </label>
      </div>
      <div className="mb-2">
        <label className="form-label font-weight-bold">
          Text Alignment:
          <select
            // value={alignment}
            onChange={e => {
              handleChangeAlignment(e.target.value);
            }}
            className="form-select mt-1"
          >
            <option value="left">Left</option>
            <option value="center">Center</option>
            <option value="right">Right</option>
            <option value="justify">Justify</option>
          </select>
        </label>
      </div>
      <div className="mb-2">
        <label className="form-label font-weight-bold">
          Font Type:
          <select
            // value={font}
            onChange={e => {
              handleChangeFont(e.target.value);
            }}
            className="form-select mt-1"
          >
            <option value="Arial">Arial</option>
            <option value="Verdana">Verdana</option>
            <option value="Helvetica">Helvetica</option>
            <option value="Times New Roman">Times New Roman</option>
            <option value="Courier New">Courier New</option>
          </select>
        </label>
      </div>
    </div>
  );
};

export default ModalStyle;
